module.exports = __webpack_public_path__ + "img/covidcover-old.ca932a34.png";